'use client';

import type { IChallengeClip } from '@repo/sdk';
import { checkVideosApi } from '@repo/sdk';
import { useEffect, useState } from 'react';

export function useCheckClipVideos(clips: IChallengeClip[]) {
  const [videoMap, setVideoMap] = useState<Record<string, boolean> | null>(null);

  useEffect(() => {
    if (clips.length === 0) {
      return;
    }

    const paths = [...new Set(clips.map((c) => c.vaultPath).filter(Boolean))] as string[];
    if (paths.length === 0) {
      setVideoMap({});
      return;
    }

    checkVideosApi({ paths })
      .then(setVideoMap)
      .catch(() => setVideoMap(null));
  }, [clips]);

  const withVideo = videoMap ? clips.filter((c) => c.vaultPath && videoMap[c.vaultPath]) : clips;

  return { videoMap, withVideo, isLoading: videoMap === null && clips.length > 0 };
}
